// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"bf7f9ea5","344":"9697ee32","422":"59cac785","492":"42ce7d59","640":"0c732c0e","727":"6127905d","771":"762a1e88"}[chunkId] + ".chunk.js";
};